"use client"

import axiosInstance from '@/lib/axios';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

const AuthContext = createContext()

export function AuthProvider({ children, initialQuickLinks = [] }) {
	const [categories, setCategories] = useState([])
	const [navPreview, setNavPreview] = useState({})
	const quickLinks = Array.isArray(initialQuickLinks) ? initialQuickLinks : []

	const getCategories = useCallback(async () => {
		try {
			const { data: { data } } = await axiosInstance.get('/categories', {
				params: { limit: 100, page: 1 }
			})
			const formattedCategories = data
				.filter((cat) => cat.slug !== 'home-page' && cat.isActive !== false)
				.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
				.map((cat) => ({
					id: cat.id,
					name: cat.name,
					nameEnglish: cat.nameEnglish,
					slug: cat.slug,
					link: `/category/${cat.slug}`,
					isSpecial: Boolean(cat.isSpecial),
				}))
			setCategories(formattedCategories)
		} catch (error) {
			console.error('Error fetching categories for header:', error)
		}
	}, [])

	const getNavPreview = useCallback(async () => {
		try {
			const response = await axiosInstance.get('/news/nav-preview')
			if (!response.data.success) return
			const map = {}
			response.data.data.forEach((entry) => {
				if (entry?.category?.id) {
					map[entry.category.id] = entry.news || []
				}
			})
			setNavPreview(map)
		} catch (error) {
			console.error('Error fetching nav preview:', error)
		}
	}, [])

	useEffect(() => { getCategories() }, [getCategories])
	useEffect(() => { getNavPreview() }, [getNavPreview])

	const specialCategories = useMemo(
		() => categories.filter((cat) => cat.isSpecial),
		[categories]
	)
	const navCategories = useMemo(
		() => categories.filter((cat) => !cat.isSpecial),
		[categories]
	)

	return (
		<AuthContext.Provider value={{ categories, navCategories, specialCategories, navPreview, quickLinks }}>
			{children}
		</AuthContext.Provider>
	)
}

export function useAuth() {
	const context = useContext(AuthContext)
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider')
	}
	return context
}
